import apiClient from './apiClient';

export default {
  listTemplates: (skip = 0, limit = 100) => apiClient.get('/task-templates', { params: { skip, limit } }),
  createTemplate: (payload) => apiClient.post('/task-templates', payload),
  getTemplate: (id) => apiClient.get(`/task-templates/${id}`),
  updateTemplate: (id, payload) => apiClient.patch(`/task-templates/${id}`, payload),
  deleteTemplate: (id) => apiClient.delete(`/task-templates/${id}`),
};
